export function formatCurrency(value: number = 0, currencyCode: string = 'USD'): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode,
    }).format(value);
  }

  export function     formatDate(date: Date) {
    return `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`;
  }